import { OrderedSet } from 'immutable';

import * as Constants from '../constants';
import { Map } from '../lib/ImmutableUtils';
import { createReducer } from '../lib/ReducerUtils';

const INITIAL_STATE = Map({
  [Constants.Feedback.Keys.FEEDBACK_IDS]: Map<$TSFixMe>(),
  [Constants.Feedback.Keys.ALL_THUMBED_TRACKS]: Map<$TSFixMe>(),
  [Constants.Feedback.Keys.FETCHED_DATA_SUCCESS_KEY]: false as boolean,
});
export type FeedbackState = typeof INITIAL_STATE;

// FEEDBACK REDUCER
export default createReducer(INITIAL_STATE, {
  [Constants.Api.ApiActions.GET_FEEDBACK_SUCCESS]: getFeedbackSuccess,
  [Constants.Api.ApiActions.GET_STATION_FEEDBACK_SUCCESS]: getStationFeedbackSuccess,
  [Constants.Api.ApiActions.ADD_FEEDBACK_SUCCESS]: addFeedbackSuccess,
  [Constants.Api.ApiActions.DELETE_FEEDBACK_SUCCESS]: deleteFeedbackSuccess,
  [Constants.Api.ApiActions.ACTION_REMOVE_THUMB_SUCCESS]: removeThumbSuccess,
  [Constants.Api.ApiActions.GET_FEEDBACK_ATTEMPT]: getFeedbackAttempt,
  [Constants.Api.ApiActions.GET_FEEDBACK_FAIL]: getFeedbackAttempt,
  [Constants.Api.ApiActions.GET_STATION_FEEDBACK_ATTEMPT]: getFeedbackAttempt,
  [Constants.Api.ApiActions.GET_STATION_FEEDBACK_FAIL]: getFeedbackAttempt,
  [Constants.StationDetails.actions.RESET_STATION_FEEDBACK_SUCCESS]: resetStationFeedbackSuccess,
});

// HELPER FUNCTIONS

function removeFeedbackByMusicId(
  state: FeedbackState,
  musicId: $TSFixMe,
  actionFeedbackId: $TSFixMe,
): FeedbackState {
  let trackToRemove = state
    .get(Constants.Feedback.Keys.ALL_THUMBED_TRACKS)
    .find(track => track.get('musicId') === musicId);
  if (actionFeedbackId) {
    trackToRemove = state
      .get(Constants.Feedback.Keys.ALL_THUMBED_TRACKS)
      .find(track => track.get('feedbackId') === actionFeedbackId);
  }

  return removeFeedbackByTrack(trackToRemove, state);
}

function removeFeedbackByTrackId(state: FeedbackState, trackId: $TSFixMe): FeedbackState {
  const trackToRemove = state
    .get(Constants.Feedback.Keys.ALL_THUMBED_TRACKS)
    .find(track => track.get('pandoraId') === trackId);

  return removeFeedbackByTrack(trackToRemove, state);
}

function removeFeedbackByTrack(track: $TSFixMe, state: FeedbackState): FeedbackState {
  if (!track) {
    // It wasn't loaded yet, nothing to remove
    return state;
  }
  const feedbackId = track.get('feedbackId');

  return state.merge({
    [Constants.Feedback.Keys.FEEDBACK_IDS]: state
      .get(Constants.Feedback.Keys.FEEDBACK_IDS)
      // @ts-expect-error
      .map(user => user.filter(id => id !== feedbackId)),
    [Constants.Feedback.Keys.ALL_THUMBED_TRACKS]: state
      .get(Constants.Feedback.Keys.ALL_THUMBED_TRACKS)
      .delete(feedbackId),
  });
}

// CASE FUNCTIONS

function getFeedbackSuccess(state: FeedbackState, action: $TSFixMe): FeedbackState {
  const key = action.webname || action.stationId;
  const feedbackIds = state.get(Constants.Feedback.Keys.FEEDBACK_IDS).get(key) || OrderedSet();
  // Prepend to list when a track has just been thumbed up (it's the most recent one)
  if (action.mostRecent) {
    return state.merge({
      [Constants.Feedback.Keys.FEEDBACK_IDS]: state
        .get(Constants.Feedback.Keys.FEEDBACK_IDS)
        .merge({
          [key]: OrderedSet(action.response.result.feedback).concat(feedbackIds),
        }),
      [Constants.Feedback.Keys.ALL_THUMBED_TRACKS]: state
        .get(Constants.Feedback.Keys.ALL_THUMBED_TRACKS)
        .merge(action.response.entities.feedback),
      [Constants.Feedback.Keys.FETCHED_DATA_SUCCESS_KEY]: true,
    });
  }
  return state.merge({
    [Constants.Feedback.Keys.FEEDBACK_IDS]: state.get(Constants.Feedback.Keys.FEEDBACK_IDS).merge({
      [key]: feedbackIds.concat(action.response.result.feedback),
    }),
    [Constants.Feedback.Keys.ALL_THUMBED_TRACKS]: state
      .get(Constants.Feedback.Keys.ALL_THUMBED_TRACKS)
      .merge(action.response.entities.feedback),
    [Constants.Feedback.Keys.FETCHED_DATA_SUCCESS_KEY]: true,
  });
}

function getStationFeedbackSuccess(state: FeedbackState, action: $TSFixMe): FeedbackState {
  // TODO-REDUCER: spike this
  return getFeedbackSuccess(state, action);
}

function addFeedbackSuccess(state: FeedbackState, action: $TSFixMe): FeedbackState {
  if (action.wasTrackThumbedUp) {
    return removeFeedbackByMusicId(state, action.response.musicId, action.response.feedbackId);
  }

  return state;
}

function deleteFeedbackSuccess(state: FeedbackState, action: $TSFixMe): FeedbackState {
  return removeFeedbackByMusicId(state, action.musicId, action.response.feedbackId);
}

function removeThumbSuccess(state: FeedbackState, action: $TSFixMe): FeedbackState {
  return removeFeedbackByTrackId(state, action.pandoraId);
}

function getFeedbackAttempt(state: FeedbackState): FeedbackState {
  return state.set(Constants.Feedback.Keys.FETCHED_DATA_SUCCESS_KEY, false);
}

function resetStationFeedbackSuccess(): FeedbackState {
  return INITIAL_STATE;
}
